__turbopack_context__.v({
  "hero": "LSingleColumn-module__O8goWa__hero",
  "heroLarge": "LSingleColumn-module__O8goWa__heroLarge",
  "main": "LSingleColumn-module__O8goWa__main",
  "root": "LSingleColumn-module__O8goWa__root",
});
